import { render, staticRenderFns } from "./document-form-video.vue?vue&type=template&id=719b26e8&scoped=true"
import script from "./document-form-video.vue?vue&type=script&lang=js"
export * from "./document-form-video.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "719b26e8",
  null
  
)

export default component.exports